import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getOffer } from '../services/orders';
import OfferSheet from '../components/Offers/OfferSheet';
import './OfferPdfPage.css';

/** LAKPED-16.4 — la hoja de oferta que sale de casa, y el envío.
 *
 *  Lo que se ve en la hoja es exactamente lo que se imprime: el PDF se saca con la impresión del
 *  navegador («Guardar como PDF»), que es lo que permite tener hoja única sin montar un generador
 *  en el servidor. Cuando haya que adjuntarla a un correo sola, habrá que generarla por detrás.
 */
const PASOS = ['Documento', 'Histórico', 'Oferta', 'PDF y envío'];


const OfferPdfPage = () => {
  const navigate = useNavigate();
  const { offerHash } = useParams();
  const [oferta, setOferta] = useState(null);
  const [error, setError] = useState(null);

  const cargar = useCallback(async () => {
    try {
      setOferta(await getOffer(offerHash));
    } catch (err) {
      setError('No se ha podido cargar la oferta.');
    }
  }, [offerHash]);

  useEffect(() => { cargar(); }, [cargar]);

  if (error) return <div className="offer-pdf"><p className="offer-pdf-error">{error}</p></div>;
  if (!oferta) return <div className="offer-pdf"><p>Cargando…</p></div>;

  // LAKPED-26/27: los pasos hechos son el camino de vuelta.
  const alHistorico = () => {
    const query = new URLSearchParams({ analysis: oferta.analysis?.hash || '' });
    if (oferta.client?.name) query.set('cliente', oferta.client.name);
    const codigo = (oferta.lines || []).find(l => l.part_code)?.part_code;
    if (codigo) query.set('codigo', codigo);
    navigate(`/offers/history?${query.toString()}`);
  };
  const irAlPaso = [
    () => navigate(`/similarity-search?documento=${oferta.analysis?.hash}`),
    alHistorico,
    () => navigate(`/offers/${offerHash}`),
  ];

  return (
    <div className="offer-pdf">
      <ol className="offer-pdf-pasos">
        {PASOS.map((titulo, i) => (
          <li key={titulo} className={i === 3 ? 'actual' : 'hecho'}>
            {i === 3 ? (
              <>
                <span className="offer-pdf-paso-num">4</span>
                {titulo}
              </>
            ) : (
              <button type="button" onClick={irAlPaso[i]} disabled={i === 0 && !oferta.analysis}>
                <span className="offer-pdf-paso-num">✓</span>
                {titulo}
              </button>
            )}
          </li>
        ))}
      </ol>

      <div className="offer-pdf-columnas">
        <OfferSheet oferta={oferta} />

        <aside className="offer-pdf-lateral">
          <div className="offer-pdf-envio">
            <h2>Seguir con la oferta</h2>
            <div className="offer-pdf-acciones">
              <button type="button" className="offer-pdf-secundario" onClick={() => navigate(`/offers/${offerHash}`)}>
                Volver a la oferta
              </button>
              <button type="button" className="offer-pdf-secundario" onClick={() => navigate('/offers')}>
                Ver todas las ofertas
              </button>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default OfferPdfPage;
